"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _getDates = require("../../../../../utils/getDates");
var _button = _interopRequireDefault(require("../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _tierRacingDays = _interopRequireDefault(require("./tier-racing-days"));
var _contactDetails = _interopRequireDefault(require("../../shared-components/contact-details"));
var _tiers = _interopRequireDefault(require("./tiers"));
var _coreApplication = _interopRequireDefault(require("../../shared-components/core-application"));
var _copyApplication = _interopRequireDefault(require("./copyApplication"));
var _setApplicationOwner = _interopRequireDefault(require("../../shared-components/application-actions/changeOwner/setApplicationOwner"));
var _dateError = _interopRequireDefault(require("./dateError"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const steps = ['core', 'copy-last-year', 'select-tiers', 'racing-days', 'contact-details'];
const initialState = {
  application: {
    siteID: null,
    numberOfDays: 2,
    clubID1: null,
    clubID2: null,
    canMoveByWeeks: 0,
    notes: null,
    contactName: null,
    contactEmail: null,
    canShareContact: false
  },
  selectedTierIDs: [],
  tierRacingOptions: {},
  currentStep: 0,
  applying: false,
  errorMessage: null,
  applicationToCopy: null
};
class NewApplicationModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onCloseCancel", () => {
      this.setState(initialState);
      this.props.onCloseCancel();
    });
    _defineProperty(this, "_toNextStep", () => {
      if (steps[this.state.currentStep] === 'core') {
        const calDatesArray = this.props.calendar.calendarDates.map(d => d.id);
        const compDates = (0, _getDates.getDates)(this.props.calendarDate.id, this.state.application.numberOfDays);
        if (!compDates.every(d => calDatesArray.includes(d))) return this.setState({
          errorMessage: /*#__PURE__*/_react.default.createElement(_dateError.default, {
            calendarDateID: this.props.calendarDate.id
          })
        });
      }
      if (steps[this.state.currentStep + 1] === 'copy-last-year' && !this._getLastYearsApplications().length) return this.setState({
        currentStep: this.state.currentStep + 2
      });
      this.setState({
        currentStep: this.state.currentStep + 1
      });
    });
    _defineProperty(this, "_toPreviousStep", () => {
      if (this.state.applicationToCopy) {
        return this.setState({
          currentStep: steps.indexOf('copy-last-year'),
          applicationToCopy: null
        });
      }
      if (steps[this.state.currentStep - 1] === 'copy-last-year' && !this._getLastYearsApplications().length) return this.setState({
        currentStep: this.state.currentStep - 2
      });
      this.setState({
        currentStep: this.state.currentStep - 1
      });
    });
    _defineProperty(this, "_canContinueToNextStep", () => {
      switch (steps[this.state.currentStep]) {
        case 'core':
          return this.state.application.siteID && this.state.application.numberOfDays && this.state.application.numberOfDays <= 7 && this.state.application.clubID1;
        case 'select-tiers':
          return !!this.state.selectedTierIDs.length;
        case 'racing-days':
          return this.state.selectedTierIDs.every(divID => this.state.tierRacingOptions[divID] && this._getCompDays().every(day => this.state.tierRacingOptions[divID][day.id]));
        case 'contact-details':
          return !!this.state.application.contactName;
        default:
          return true;
      }
    });
    _defineProperty(this, "_acceptError", () => {
      this.setState({
        errorMessage: null
      });
    });
    _defineProperty(this, "_onApply", () => {
      if (this.state.applying) return;
      this.setState({
        applying: true
      });
      if (this.state.applicationToCopy) {
        return this.props.copyApplication(this.state.applicationToCopy, this.state.application).then(() => this._onCloseCancel());
      }
      this.props.apply(this.state.application, JSON.stringify(this.state.tierRacingOptions)).then(result => {
        if (result && !result.success) {
          this.setState({
            errorMessage: /*#__PURE__*/_react.default.createElement("p", null, result.errorMessage),
            applying: false
          });
        } else {
          this._onCloseCancel();
        }
      });
    });
    _defineProperty(this, "_setValue", (value, field) => {
      this.setState({
        application: {
          ...this.state.application,
          [field]: value
        }
      });
    });
    _defineProperty(this, "_setSelected", (field, value) => {
      this.setState({
        application: {
          ...this.state.application,
          [field]: value
        }
      });
    });
    _defineProperty(this, "_setTierRacingOption", (divID, dayID, value) => {
      if (this.state.tierRacingOptions[divID]) {
        this.setState({
          tierRacingOptions: {
            ...this.state.tierRacingOptions,
            [divID]: {
              ...this.state.tierRacingOptions[divID],
              [dayID]: value
            }
          }
        });
      } else {
        this.setState({
          tierRacingOptions: {
            ...this.state.tierRacingOptions,
            [divID]: {
              [dayID]: value
            }
          }
        });
      }
    });
    _defineProperty(this, "_getSelectedTiers", () => {
      const selectedTierIDs = this.state.selectedTierIDs;
      return this.props.defaultTiersByYear.filter(tier => selectedTierIDs.includes(tier.tierRef));
    });
    _defineProperty(this, "_toggleTierSelection", id => {
      const selectedTierIDs = this.state.selectedTierIDs;
      if (selectedTierIDs.includes(id)) {
        this.setState({
          selectedTierIDs: selectedTierIDs.filter(div => div !== id)
        });
      } else {
        this.setState({
          selectedTierIDs: [...selectedTierIDs, id]
        });
      }
    });
    _defineProperty(this, "_getCompDays", () => {
      const startDate = new Date(this.props.calendarDate.id);
      const startDay = startDate.getDay();
      const compDays = [];
      for (let i = 0; i < this.state.application.numberOfDays; i++) {
        compDays.push({
          id: i,
          weekDay: (i + startDay) % 7
        });
      }
      return compDays;
    });
    _defineProperty(this, "_getLastYearsApplications", () => {
      // TODO - Revisit copy application function
      // The "copy" from last year fuctionality is still there but needs testing first with new tiers
      // Also, for 2026, there is nothing to copy

      // For now will return empty array for last years apps which will stop copying from being presented.
      return [];
      // return this.props.lastYear.applications.filter(
      //   (app) =>
      //     app.applicationStatusRef === 'COMP' &&
      //     app.siteID === this.state.application.siteID &&
      //     app.clubID1 === this.state.application.clubID1 &&
      //     ((!app.clubID2 && !this.state.application.clubID2) || app.clubID2 === this.state.application.clubID2) &&
      //     app.numberOfDays === this.state.application.numberOfDays,
      // );
    });
    // note if application is selected to copy then we skip straight to the last step
    _defineProperty(this, "_onSelectApplication", applicationID => {
      this.setState({
        applicationToCopy: applicationID,
        currentStep: steps.length - 1
      });
    });
  }
  render() {
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, this.state.errorMessage ? /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._acceptError,
      type: "primary"
    }, "Close") : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCloseCancel
    }, "Cancel"), this.state.currentStep === 0 ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toPreviousStep
    }, "Back"), this.state.currentStep < steps.length - 1 ? /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toNextStep,
      type: "primary",
      disabled: !this._canContinueToNextStep()
    }, "Next") : /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onApply,
      type: "primary",
      disabled: !this._canContinueToNextStep()
    }, "Submit Application")));
    const application = {
      ...this.state.application
    };
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: 'Managed Calendar Application for ' + (0, _occasion.default)(this.props.calendarDate.id, 'D MMMM YYYY'),
      onClose: this._onCloseCancel,
      buttons: modalButtons,
      size: "lg"
    }, this.state.errorMessage ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "warning"
    }, this.state.errorMessage) : steps[this.state.currentStep] === 'core' ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_coreApplication.default, {
      application: application,
      setSelected: this._setSelected,
      setValue: this._setValue
    })) : steps[this.state.currentStep] === 'copy-last-year' ? /*#__PURE__*/_react.default.createElement(_copyApplication.default, {
      applications: this._getLastYearsApplications(),
      onSelectApplication: this._onSelectApplication,
      calendarDateID: this.props.calendarDate.id
    }) : steps[this.state.currentStep] === 'select-tiers' ? /*#__PURE__*/_react.default.createElement(_tiers.default, {
      calendarID: this.props.calendarDate.calendarID,
      selectedTierIDs: this.state.selectedTierIDs,
      toggleTierSelection: this._toggleTierSelection
    }) : steps[this.state.currentStep] === 'racing-days' ? this._getSelectedTiers().map(div => /*#__PURE__*/_react.default.createElement(_tierRacingDays.default, {
      key: div.id,
      defaultTier: div,
      competitionDays: this._getCompDays(),
      tierRacingOptions: this.state.tierRacingOptions[div.tierRef] || {},
      onChange: this._setTierRacingOption.bind(this, div.tierRef)
    })) : steps[this.state.currentStep] === 'contact-details' ? !this.props.userIsCalendarOfficer ? /*#__PURE__*/_react.default.createElement(_contactDetails.default, {
      application: {
        ...application,
        contactEmail: this.props.userEmail
      },
      setValue: this._setValue
    }) : /*#__PURE__*/_react.default.createElement(_setApplicationOwner.default, {
      userIsCalendarOfficer: this.props.userIsCalendarOfficer,
      application: {
        ...application
      },
      setValue: this._setValue
    }) : null);
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(NewApplicationModal, "partialQueries", {
  CalendarDates: {
    id: true,
    calendarID: true
  }
});
var _ref = _mergeBqlQueries({
  tierRef: true
}, _tierRacingDays.default.partialQueries.DefaultTier);
var _ref2 = {
  id: true,
  applications: _mergeBqlQueries({
    id: true,
    clubID1: true,
    clubID2: true,
    siteID: true,
    applicationStatusRef: true
  }, _copyApplication.default.partialQueries.Application)
};
var _default = exports.default = (0, _reactBicycle.connect)(NewApplicationModal, props => ({
  userIsCalendarOfficer: true,
  userEmail: true,
  ["defaultTiersByYear(yearID:" + JSON.stringify(+props.calendarDate.calendarID) + ")"]: _ref,
  ["calendar(yearID:" + JSON.stringify(props.calendarDate.calendarID - 1) + ") as lastYear"]: _ref2
}), (client, props) => ({
  apply(application, tierRaces) {
    return client.update('Application.create', {
      calendarID: props.calendarDate.calendarID,
      calendarDateID: props.calendarDate.id,
      ...application,
      tierRaces
    });
  },
  copyApplication(applicationToCopy, application) {
    //TODO - reinstate for 2028 applications after testing
    // return client.update('Application.copyApplication', {
    //   calendarID: props.calendarDate.calendarID,
    //   calendarDateID: props.calendarDate.id,
    //   applicationToCopy,
    //   ...application,
    // });
    return;
  }
}));